// extracted by mini-css-extract-plugin
export default {"PlainFeature":"wb_a bhn_b"};